<template>
    <Modal
        v-model="showModal"
        draggable
        sticky
        title="Edit Project Log Dispute"
        width="600"
        no-footer
        class="updateProjectLogDispute"
    >
        <Form
            ref="form"
            :model="form"
            :rules="ruleInline"
            label-position="left"
            class="update-project-log-dispute-wrapper"
        >
            <Row>
                <Col span="12">
                    <FormItem label="Date">
                        <DatePicker v-model="form.date" type="date" format="dd-MMM-yyyy" transfer disabled />
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="Project">
                        <Input v-model="projectName" disabled />
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="16">
                <Col span="12">
                    <FormItem label="Initial Start Time">
                        <TimePicker
                            v-model="form.initialStartTime"
                            format="HH:mm"
                            transfer
                            disabled
                            style="width: 100%"
                        />
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="Initial End Time">
                        <TimePicker
                            v-model="form.initialEndTime"
                            format="HH:mm"
                            transfer
                            disabled
                            style="width: 100%"
                        />
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="16">
                <Col span="12">
                    <FormItem label="Requested Start Time" prop="requestedStartTime">
                        <TimePicker
                            v-model="form.requestedStartTime"
                            format="HH:mm"
                            confirm
                            transfer
                            style="width: 100%"
                        />
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="Requested End Time" prop="requestedEndTime">
                        <TimePicker
                            v-model="form.requestedEndTime"
                            format="HH:mm"
                            confirm
                            transfer
                            style="width: 100%"
                        />
                    </FormItem>
                </Col>
            </Row>
            <Row>
                <Col span="24">
                    <FormItem label="Reason" prop="reason">
                        <Input
                            v-model="form.reason"
                            type="textarea"
                            :autosize="{ minRows: 2, maxRows: 5 }"
                            placeholder="Enter reason..."
                        />
                    </FormItem>
                </Col>
            </Row>
        </Form>
        <div style="text-align: right; margin-top: 20px">
            <Button class="pt-btn-2" style="margin-right: 10px" @click="showModal = false">CANCEL</Button>
            <Button class="pt-btn-3" :loading="isLoading" @click="handleUpdate">SUBMIT</Button>
        </div>
    </Modal>
</template>

<script>
import moment from 'moment';
import { updateTimeDispute } from '@/services/requests.services';

export default {
    data() {
        return {
            showModal: false,
            isLoading: false,
            requestId: null,
            projectName: '',
            form: {
                date: '',
                initialStartTime: '',
                initialEndTime: '',
                requestedStartTime: '',
                requestedEndTime: '',
                reason: '',
            },
            ruleInline: {
                requestedStartTime: [{ required: true, message: 'Please select start time', trigger: 'change' }],
                requestedEndTime: [{ required: true, message: 'Please select end time', trigger: 'change' }],
                reason: [{ required: true, message: 'Please enter reason', trigger: 'blur' }],
            },
        };
    },
    methods: {
        openModal(data) {
            this.requestId = data._id;
            this.projectName = data.requestedData.project ? data.requestedData.project.name : '-';
            this.form.date = moment(data.requestedStart).utc().toDate();

            if (data.currentData) {
                this.form.initialStartTime = moment(data.currentData.clockInTime).utc().format('HH:mm');
                this.form.initialEndTime = moment(data.currentData.clockOutTime).utc().format('HH:mm');
            } else {
                this.form.initialStartTime = '';
                this.form.initialEndTime = '';
            }

            this.form.requestedStartTime = moment(data.requestedData.clockInTime).utc().format('HH:mm');
            this.form.requestedEndTime = moment(data.requestedData.clockOutTime).utc().format('HH:mm');
            this.form.reason = data.reason;

            this.showModal = true;
        },
        handleUpdate() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.isLoading = true;
                    const dateStr = moment(this.form.date).format('YYYY-MM-DD');
                    const payload = {
                        requestedStart: moment.utc(`${dateStr} ${this.form.requestedStartTime}`).toISOString(),
                        requestedEnd: moment.utc(`${dateStr} ${this.form.requestedEndTime}`).toISOString(),
                        reason: this.form.reason,
                    };

                    updateTimeDispute(this.requestId, payload)
                        .then(() => {
                            this.$Message.success('Project log dispute updated successfully');
                            this.$emit('reload');
                            this.showModal = false;
                        })
                        .catch(() => {
                            this.$Message.error('Failed to update project log dispute');
                        })
                        .finally(() => {
                            this.isLoading = false;
                        });
                }
            });
        },
    },
};
</script>
